import React, { useContext, useEffect, useState } from "react";
import Game from "../Game/Game";
import RightSideBar from "../RightSideBar/RightSideBar";
import RightSideBarSky from "../RightSideBar/RightSideBarSky";
import styled from "styled-components";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import TeamNames from "../TopBar/TeamNames";
import Goal from "../TopBar/Goal";
import { UIContext } from "../../contexts/UIContext";
import ClockEdit from "../ClockEdit/ClockEdit";
import { Route, Switch, useParams } from "react-router";
import { useLazyQuery } from "@apollo/client";
import gql from "graphql-tag";
import Goals from "../Goals/Goals";
import Penalties from "../Penalties/Penalties";
import ServerStatus from "../ServerStatus/ServerStatus";
import { APIContext } from "../../contexts/APIContext";
import { DataContext } from "../../contexts/DataContext";
import useLocalStorage from "../../Hooks/useLocalStorage";
const LINEUP_FIELDS = gql`
  fragment LINEUP_FIELDS on LineupObject {
    home {
      squad {
        _id
        shirt_number
        opta_shirt_number
        position
        stats
        player {
          _id
          first_name
          last_name
          first_name_upper
          last_name_upper
          short_name
          short_name_upper
          nationality {
            _id
            code
            name
          }
          image
          stories
          oval_ID
        }
      }
      order
      yellow_card
      dbl_yellow_card
      red_card
      sub_order
      subbed
      captain
    }
    away {
      squad {
        _id
        shirt_number
        opta_shirt_number
        position
        stats
        player {
          _id
          first_name
          last_name
          first_name_upper
          last_name_upper
          short_name
          short_name_upper
          nationality {
            _id
            code
            name
          }
          image
          stories
          oval_ID
        }
      }
      order
      yellow_card
      dbl_yellow_card
      red_card
      sub_order
      subbed
      captain
    }
  }
`;
const GAME_BY_ID = gql`
  ${LINEUP_FIELDS}
  query GameByID($id: String) {
    gameById(id: $id) {
      _id
      oval_ID
      time
      description
      date
      home_team_kit
      away_team_kit
      stadium {
        opta_name
        name
      }
      competition {
        oval_ID
        name
        competition_type
        badge
        secondary_badge
        flag_path
        fighter_path
        fighter_full_path
        categories
      }
      home_scorers
      away_scorers
      home_penalties
      away_penalties
      home_player_stats
      away_player_stats
      home_player_ciq_stats
      away_player_ciq_stats
      home_team_stats
      away_team_stats
      lineup {
        ...LINEUP_FIELDS
      }
      home_fighter {
        _id
        first_name
        last_name
        short_name
        image
        image_2
        stories
        corner
        weight
        wins
        losses
        draws
        knockouts
        height
        hometown
        reach
        legreach
        style
        age
        shorts_colour
        nationality {
          code
        }
      }
      away_fighter {
        _id
        first_name
        last_name
        short_name
        image
        image_2
        stories
        corner
        weight
        wins
        losses
        draws
        knockouts
        height
        hometown
        reach
        legreach
        style
        age
        shorts_colour
        nationality {
          code
        }
      }
      live_data
      prediction_data
      home_phase
      away_phase
      metres_gained
      number_of_rounds
      gold_fight
      championship_bar
      round_minutes
      title
      season {
        _id
        oval_ID
      }
      commentators {
        first_name
        last_name
      }
      mc {
      first_name
      last_name
      }
      referee {
        _id
        first_name
        last_name
      }
      judges {
        _id
        first_name
        last_name
      }
      home_sets
      away_sets
      winner
      completed
      winnerby
    }
  }
`;

const GAME_SUBSCRIPTION = gql`
  ${LINEUP_FIELDS}
  subscription GameUpdated($id: String!) {
    gameUpdated(_id: $id) {
      _id
      home_team_kit
      away_team_kit
      lineup {
        ...LINEUP_FIELDS
      }
      live_data
      prediction_data
      home_scorers
      away_scorers
      home_penalties
      away_penalties
      home_formation
      away_formation
      home_player_stats
      away_player_stats
      home_player_ciq_stats
      away_player_ciq_stats
      home_team_stats
      away_team_stats
      season {
        _id
        oval_ID
      }
      commentators {
        first_name
        last_name
      }
      home_phase
      away_phase
      metres_gained
      home_player_stats
      away_player_stats
      home_player_ciq_stats
      away_player_ciq_stats
      home_team_stats
      away_team_stats
      home_sets
      away_sets
      number_of_rounds
      gold_fight
      championship_bar
      round_minutes
      title
      winner
      completed
      winnerby
      home_fighter {
        _id
        first_name
        last_name
        short_name
        image
        image_2
        stories
        shorts_colour
        nationality {
          code
        }
      }
      away_fighter {
        _id
        first_name
        last_name
        short_name
        image
        image_2
        stories
        shorts_colour
        nationality {
          code
        }
      }
    }
  }
`;

const Main = styled.div`
  display: flex;
  width: 100%;
`;
const Content = styled.div`
  display: flex;
  margin-left: 1em;
  margin-right: 1em;
  margin-top: 1em;
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
`;
const RightBar = styled.div`
  display: flex;
  width: 300px;
  box-shadow: -3px 1px 3px 0 rgb(0 0 0 / 42%);
`;
const LeftBar = styled.div`
  display: flex;
  width: 44px;
  box-shadow: 3px -1px 3px 0 rgb(0 0 0 / 42%);
  background-color: #202731;
`;
export default function Live({ setSelectedPlayer, selectedPlayer, }) {
  let { gameID } = useParams();
  const [game, setGame] = useState();
  const [getGame, { data, subscribeToMore }] = useLazyQuery(GAME_BY_ID);
  const [homeManager, setHomeManager] = useState();
  const [awayManager, setAwayManager] = useState();
  const [mode, setMode] = useLocalStorage('hyper-combat-mode', "Sky Boxing");
  useEffect(() => {
      if (game?.competition?.competition_type != "") {
        setMode(game?.competition?.competition_type)
      }
    })
  useEffect(() => {
    if (gameID) {
      getGame({ variables: { id: gameID } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameID]);

  useEffect(() => {
    let unsubscribe;

    if (subscribeToMore) {
      console.log("Subscribed");
      unsubscribe = subscribeToMore({
        document: GAME_SUBSCRIPTION,
        variables: { id: gameID },
        updateQuery: (prev, { subscriptionData }) => {
          if (!subscriptionData.data) return prev;

          const updatedGame = subscriptionData.data.gameUpdated;
          let newGame = {
            gameById: { ...prev.gameById, ...updatedGame },
          };

          updateGraphic("ScoreBug", {
            game: newGame,
          });
          return newGame;
        },
      });
    }
    return () => {
      console.log("Unsubscribed");
      unsubscribe && unsubscribe();
    };
  }, [subscribeToMore, gameID]);


  useEffect(() => {
    if (data) {
      setGame(data.gameById);
    }
  }, [data]);

  const { goal, setGoal } = useContext(UIContext);
  const { gamesByDate } = useContext(DataContext);
  const {
    previewGraphic,
    animateGraphic,
    graphicInPreview,
    animateOffGraphic,
    updateGraphic,
    clearPVW,
  } = useContext(GraphicsContext);
  const { updateGame } = useContext(APIContext);



  if (!game) return <div>Loading</div>;

  return (
    game && (
      <Main>
        <Content>
          {!goal && (
            <TeamNames
              setSelectedPlayer={setSelectedPlayer}
              homeTeam={game.home_team}
              awayTeam={game.away_team}
              game={game}
            />
          )}
          {goal && (
            <Goal
              goal={goal}
              setGoal={setGoal}
              cancel={() => {
                updateGame({
                  id: game._id,
                  home_scorers: game.home_scorers.filter((g) => g.player),
                  away_scorers: game.away_scorers.filter((g) => g.player),
                });
                setGoal();
              }}
            />
          )}

          <Switch>
            <Route path="/:gameID/penalties">
              <Penalties game={game} />
            </Route>
            <Route path="/:gameID/clock">
              <ClockEdit game={game} />
            </Route>
            <Route path="/:gameID/goals">
              <Goals
                game={game}
                homeLineup={game?.lineup?.home}
                awayLineup={game?.lineup?.away}
                setGoal={setGoal}
              />
            </Route>

            <Route path="/:gameID">
              <Game
                setHomeManager={setHomeManager}
                setAwayManager={setAwayManager}
                setGoal={setGoal}
                goal={goal}
                game={game}
                setSelectedPlayer={setSelectedPlayer}
                selectedPlayer={selectedPlayer}
              />
              {(window.ENV?.REACT_APP_VIZ || process.env.REACT_APP_VIZ) && (
                <ServerStatus />
              )}
            </Route>
          </Switch>
        </Content>
        {mode === "Total Kombat" && (
        <RightBar>
          <RightSideBar
            homeManager={homeManager}
            awayManager={awayManager}
            game={game}
            updateGame={updateGame}
            previewGraphic={previewGraphic}
            graphicInPreview={graphicInPreview}
            animateGraphic={animateGraphic}
            animateOffGraphic={animateOffGraphic}
            updateGraphic={updateGraphic}
            selectedPlayer={selectedPlayer}
            clearPreview={clearPVW}
            gamesByDate={gamesByDate}
          />
        </RightBar>
        )}
        {mode === "Sky Boxing" && (
        <RightBar>
          <RightSideBarSky
            homeManager={homeManager}
            awayManager={awayManager}
            game={game}
            updateGame={updateGame}
            previewGraphic={previewGraphic}
            graphicInPreview={graphicInPreview}
            animateGraphic={animateGraphic}
            animateOffGraphic={animateOffGraphic}
            updateGraphic={updateGraphic}
            selectedPlayer={selectedPlayer}
            clearPreview={clearPVW}
            gamesByDate={gamesByDate}
          />
        </RightBar>
        )}
      </Main>
    )
  );
}
